import request from "../utils/request";
//获取列表
export function getDataList(params) {
  return request({
    url: `/dataset/list?pageNum=${params.currentPage}&pageSize=${params.currentPageSize}&name=${params.dataListName}&appId=${params.relationApp}&status=${params.status}`,
    method: "get"
  });
}
//更具id查看列表信息数据
export function getDataById(params) {
  return request({
    url: `/dataset/query?id=${params.id}`,
    method: "get"
  });
}
//删除数据集
export function deleteDataById(params) {
  return request({
    url: "/dataset/delete",
    method: "post",
    data: {
      id: params.id
    }
  });
}
//上线or下线
export function dataOnOrOff(params) {
  return request({
    url: "/dataset/onOrOff",
    method: "post",
    data: {
      id: params.id
    }
  });
}
//编辑数据集
export function dataEdit(params,list,id) {
  return request({
    url: "/dataset/update",
    method: "post",
    data: {
      dataSetCO: {
        id,
        name: params.name,
        appId: params.relationApp-0,
        country:JSON.stringify(params.country),
        appVersion:params.appVersion==={}?'':JSON.stringify(params.appVersion),
        apiVersion:params.apiVersion==={}?'':JSON.stringify(params.apiVersion),
        dataRelation:JSON.stringify(list),
        comment:params.remarks
    }
    }
  });
}
//新建数据集
export function dataCreate(params,list) {
  return request({
    url: "/dataset/add",
    method: "post",
    data: {
      dataSetCO: {
        name: params.name,
        appId: params.relationApp-0,
        country:JSON.stringify(params.country),
        appVersion:params.appVersion==={}?'':JSON.stringify(params.appVersion),
        apiVersion:params.apiVersion==={}?'':JSON.stringify(params.apiVersion),
        dataRelation:JSON.stringify(list),
        comment:params.remarks
    }
    }
  });
}

//关联应用列表
export function getaAllRelationApp() {
  return request({
    url: "/app/all",
    method: "get"
  });
}

//获取关联应用的数据关联
export function getDataRelation(params) {
  return request({
    url: "/dataset/getDataRelation?appId="+params.id,
    method: "get"
  });
}

//获取所有页面
export function getAllPage(params={}) {
   const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
  return request({
    url: `/page/all?${queryString}`,
    method: "get"
  });
}
